module.exports = __webpack_public_path__ + "static/media/lion_new.580baae0.svg";